import React, { Fragment } from "react";
import Sidebar from "../Components/Sidebar";
import EditColors from "../Components/Colors/EditColorModal";

function EditColor() {
  return (
    <Fragment>
      <div class="container-fluid">
        <div className="row">
          <div className="col-sm-3 sidebarss">
            <Sidebar />
          </div>
          <div className="col-sm-9 ssidebar">
            <EditColors />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default EditColor;
